import React, { useState } from 'react';
import { VscChromeClose } from 'react-icons/vsc';

export const TagInput = ({ tags, setTags }) => {
    const [inputValue, setInputValue] = useState('');

    const handleKeyDown = (e) => {
        if (e.key !== 'Enter' || !inputValue.trim()) return;
        e.preventDefault();
        const newTag = inputValue.trim();
        if (!tags.includes(newTag)) {
            setTags([...tags, newTag]);
        }
        setInputValue('');
    };

    const removeTag = (tagToRemove) => {
        setTags(tags.filter(tag => tag !== tagToRemove));
    };

    return (
        <div>
            <div className="flex flex-wrap gap-2 p-2 bg-2 border border-line rounded-lg">
                {tags.map(tag => (
                    <span key={tag} className="flex items-center gap-2 bg-[#5652CF]/20 text-blue-300 text-sm font-medium px-3 py-1 rounded-full">
                        {tag}
                        <button onClick={() => removeTag(tag)} className="text-blue-200 hover:text-white">
                            <VscChromeClose />
                        </button>
                    </span>
                ))}
                <input
                    type="text"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder="Type header and press Enter..."
                    className="flex-grow bg-transparent outline-none text-p-text placeholder-s-text p-1"
                />
            </div>
        </div>
    );
};